import { call, put, takeLatest } from "redux-saga/effects";
import {
  addGeneralInformationAction,
  getAllTCDocumentListAction,
  getGeneralInformationAction,
  getTCDocumentAction,
  getUploadFileKeyAction,
  setAddGeneralInformationAction,
  setAllTCDocumentListAction,
  setConfirmationODTTemplateAction,
  setContractODTTemplateAction,
  setEstimateODTTemplateAction,
  setGeneralInformationAction,
  setInvoiceODTTemplateAction,
  setQuoteODTTemplateAction,
  setTCDocumentAction,
  setUpdateTCDocumentAction,
  updateGeneralInformationAction,
  updateTCDocumentAction,
} from "../reducers/documentSlice";
import {
  putUploadFileAction,
  setLoaderAction,
  setNotificationAction,
} from "../reducers/mmymSlice";
import { callAPI, handleError, handleSuccess } from "../api/api";

/**
 * This function for call the user profile
 *
 * @param {*} payload
 */

function* getAllTCDocumentListSaga(action: any): any {
  yield put(setLoaderAction(true));
  yield put(setNotificationAction({ message: [], severity: "error" }));
  try {
    const apiResponse = yield call<any>(callAPI, {}, "get", `client/docs`);
  
    if (apiResponse?.success === true) {
      // Filter for the document with name "terms_conditions" after trimming
      const filteredDocument = apiResponse.data.find(
        (doc: any) => doc.name.trim() === "terms_conditions"
      );
      yield put(setAllTCDocumentListAction(filteredDocument));
      // estimate odt template
      const estimateDoc = apiResponse.data.find(
        (doc: any) => doc.name.trim() === "estimate"
      );
      const quoteDoc = apiResponse.data.find(
        (doc: any) => doc.name.trim() === "quote"
      );
      const confirmationDoc = apiResponse.data.find(
        (doc: any) => doc.name.trim() === "confirmation"
      );
      const invoiceDoc = apiResponse.data.find(
        (doc: any) => doc.name.trim() === "invoice"
      );

      const contractDocs = apiResponse.data.filter((doc: any) =>
        /^storage-contract(?:-\d+)?$/.test(doc?.name?.trim() || ""),
      );
      yield put(setEstimateODTTemplateAction(estimateDoc));
      yield put(setQuoteODTTemplateAction(quoteDoc));
      yield put(setConfirmationODTTemplateAction(confirmationDoc));
      yield put(setInvoiceODTTemplateAction(invoiceDoc));
      yield put(setContractODTTemplateAction(contractDocs));
    }
  } catch (error: any) {
   
    error?.response && handleError(error?.response?.data);
    error?.code === "ERR_NETWORK" && handleError(error);
  }
  yield put(setLoaderAction(false));
}

function* getTCDocumentSaga(payload: any): any {
    const { docName } = payload?.payload;
  yield put(setLoaderAction(true));
  yield put(setNotificationAction({ message: [], severity: "error" }));
  try {
    const apiResponse = yield call<any>(
      callAPI,
      {},
      "get",
      `client/docs?name=${docName}`
    );
  
    if (apiResponse?.success === true) {
      yield put(setTCDocumentAction(apiResponse?.data));
    }
  } catch (error: any) {
    
    error?.response && handleError(error?.response?.data);
    error?.code === "ERR_NETWORK" && handleError(error);
  }
  yield put(setLoaderAction(false));
}

function* updateTCDocumentSaga(payload: any[]): any {
  yield put(setLoaderAction(true));
  yield put(setNotificationAction({ message: [], severity: "error" }));
  try {
    const apiResponse = yield call<any>(callAPI, payload, "put", `client/docs`);
   
    if (apiResponse?.success === true) {
      apiResponse && handleSuccess(apiResponse);
      yield put(setUpdateTCDocumentAction(true));
      yield put(getAllTCDocumentListAction());
      apiResponse && handleSuccess(apiResponse);
    }
  } catch (error: any) {
   
    // error?.response && handleError(error?.response?.data)
    error?.response && handleError(error?.response);
    error?.code === "ERR_NETWORK" && handleError(error);
  }
  yield put(setLoaderAction(false));
}

function* getUploadFileKeySaga(payload: any): any {
 
  const {
    fileName,
    fileType,
    body,
    keepPublic = false,
    page = "",
    templatesName,
  } = payload?.payload;
  yield put(setLoaderAction(true));
  yield put(setNotificationAction({ message: [], severity: "error" }));
  try {
    const apiResponse = yield call<any>(
      callAPI,
      payload,
      "get",
      `client/upload?fileName=${fileName}&fileType=${encodeURIComponent(fileType || "")}&keepPublic=${keepPublic}`
    );

    if (apiResponse?.success === true) {
      yield put(
        putUploadFileAction({
          url: apiResponse?.data?.uploadURL,
          body: body,
          fileType,
          fileKey: apiResponse?.data?.key,
          page,
          templatesName:
            templatesName ||
            apiResponse?.data?.templatesName?.replace(/^templates\//, ""),
        })
      );
      // yield put(updateTCDocumentAction({name:'terms_conditions', s3key: apiResponse?.data?.key}));
      // yield put(setChangePasswordAction(true));
    }
  } catch (error: any) {
    console.log("Catch Error-", error);
    error?.response && handleError(error?.response);
    error?.code === "ERR_NETWORK" && handleError(error);
    // yield put(setChangePasswordAction(false));
  }
  // yield put(setLoaderAction(false))
}

// general inforamtion 
function* getGeneralInformationSaga():any {
  yield put(setLoaderAction(true))
  
  try {
    
      const res = yield call<any>(callAPI, {}, 'get', `client/general-info`)
    
      if (res?.data) {
          yield put(setGeneralInformationAction(res?.data))
      }
  } catch (error:any) {
     
      error?.response && handleError(error?.response, [401]);
      error?.code === "ERR_NETWORK" && handleError(error);
  }
  yield put(setLoaderAction(false))  
} 

function* addGeneralInformationSaga(payload: any[]):any {
  yield put(setLoaderAction(true))
  try {
   
      const apiResponse = yield call<any>(callAPI, payload, 'post', 'client/general-info')

      if (apiResponse?.success === true) {
          apiResponse && handleSuccess(apiResponse);
          yield put(setAddGeneralInformationAction(true));
      }
  } catch (error: any) {
    
      error?.response && handleError(error?.response);
      error?.code === "ERR_NETWORK" && handleError(error);
      yield put(setAddGeneralInformationAction(false));
  }
  yield put(setLoaderAction(false))
}

function* updateGeneralInformationSaga(payload: { payload: any }): any {
  yield put(setLoaderAction(true))
  try {
    const { id, ...newPayload } = payload?.payload

      const apiResponse = yield call<any>(callAPI,  {payload:newPayload} , 'put', `client/general-info/${id}`)

      if (apiResponse?.success === true) {
        apiResponse && handleSuccess(apiResponse);
          yield put(setAddGeneralInformationAction(true));
      }
  } catch (error: any) {
    
      error?.response && handleError(error?.response);
      error?.code === "ERR_NETWORK" && handleError(error);
      yield put(setAddGeneralInformationAction(false));
  }
  yield put(setLoaderAction(false))
}

export function* watchDocument() {
  yield takeLatest<any>(getAllTCDocumentListAction, getAllTCDocumentListSaga);
  yield takeLatest<any>(getTCDocumentAction, getTCDocumentSaga);
  yield takeLatest<any>(updateTCDocumentAction, updateTCDocumentSaga);
  yield takeLatest<any>(getUploadFileKeyAction, getUploadFileKeySaga);
  yield takeLatest<any>(getGeneralInformationAction, getGeneralInformationSaga);
  yield takeLatest<any>(addGeneralInformationAction, addGeneralInformationSaga);
  yield takeLatest<any>(
    updateGeneralInformationAction,
    updateGeneralInformationSaga
  );
}
